module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.blog) ? _c('div', {
    staticClass: "blog-template"
  }, [_c('div', {
    staticClass: "blog-template__title",
    domProps: {
      "innerHTML": _vm._s(_vm.blog.title.rendered)
    }
  }), _c('div', {
    staticClass: "blog-template__date",
    domProps: {
      "innerHTML": _vm._s("<span>" + _vm.blog.date.slice(5, 7) + "</span>/<span>" + _vm.blog.date.slice(8, 10) + "</span>/<span>" + _vm.blog.date.slice(0, 4) + "</span>")
    }
  }), _c('img', {
    attrs: {
      "src": _vm.blog.better_featured_image.source_url
    }
  }), _c('div', {
    staticClass: "blog-template__body",
    domProps: {
      "innerHTML": _vm._s(_vm.blog.acf.body)
    }
  }), _c('a', {
    staticClass: "blog-template__back-link",
    on: {
      "click": _vm.redirectToBlogs
    }
  }, [_vm._v("Back to Blogs")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ba1f8e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog-template/blog-template.pug
// module id = 635
// module chunks = 1